import { useConfig } from '../../ConfigContext';
import React from 'react';
import ClassicControls from './ClassicControls';
import CropperComponent from './CropperComponent';
import MultipleImagesComponent from './MultipleImagesComponent';
import { cropSlides, designSlides } from '../Carousel/carouselData';
import PairControls from './PairControls';

export default function OverlayHorizontal({ thisRef, localSize }) {
  const { general, setGeneralState, size } = useConfig();

  const onCropComplete = (handler) => (croppedArea, croppedAreaPixels) => {
    handler(croppedAreaPixels);
  };
  const pluginUrl = window.GBCONF ? window.GBCONF.pluginUrl : '';
  let widthCoefficient = 0.5;
  let heightCoefficient = 0.65;
  let heightPaddingCoefficient = 0;
  let textBlockWidthCoefficient = 0.27;
  let textBlockMarginLeftCoefficient = 0.025;
  let paddingTopCoefficient = 0;

  let textBottomCoefficient = 0;

  if (general.glassType === 'pair' || general.glassType === 'classic') {
    if (
      cropSlides[general.selectedCarouselCropIndex].cssClass === 'thinner-mask'
    ) {
      widthCoefficient = 0.4;
      textBlockMarginLeftCoefficient = 0.1;
    }

    if (
      cropSlides[general.selectedCarouselCropIndex].cssClass === 'flatter-mask'
    ) {
      heightCoefficient = 0.55;
    }

    if (
      designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
        'weddingBackground' &&
      general.glassType === 'pair'
    ) {
      textBottomCoefficient = 0.22;
    } else if (
      designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
        'heartBackground' &&
      general.glassType === 'pair'
    ) {
      textBottomCoefficient = -20;
    } else if (
      designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
        'ampBackground' &&
      general.glassType === 'pair'
    ) {
      textBottomCoefficient = -20;
    }
  }

  if (general.glassType === 'multiple') {
    widthCoefficient = 0.82;
    heightCoefficient = 0.7;
  }

  return (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        top: 0,
        margin: 'auto',
        paddingTop: size.height * paddingTopCoefficient,
        paddingRight: 0,
        height: size.height,
        width: size.width,
      }}
    >
      {(general.glassType === 'pair' || general.glassType === 'classic') && (
        <div
          className={cropSlides[general.selectedCarouselCropIndex].cssClass}
          style={{
            width: size.width * widthCoefficient,
            height: size.height * heightCoefficient,
            marginBottom: size.height * heightPaddingCoefficient,
            background: general.imageSrc ? 'transparent' : '#fff',
            zIndex: 1,
            pointerEvents: 'auto',
          }}
        >
          <div
            className="crop-container"
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            }}
            ref={thisRef}
          >
            <CropperComponent
              isRounded={
                cropSlides[general.selectedCarouselCropIndex].cssClass ===
                  'circle-mask' &&
                (general.glassType === 'classic' ||
                  general.glassType === 'pair')
              }
              itemObject={general}
              overlayWidth={localSize.width}
              overlayHeight={localSize.height}
              onCropCompleteFunction={onCropComplete((px) =>
                setGeneralState({ croppedAreaPixels: px })
              )}
              onCropChangeFunction={(c) => setGeneralState({ crop: c })}
              onZoomChangeFunction={(z) => setGeneralState({ zoom: z })}
            />
          </div>
        </div>
      )}

      {/* Textové vrstvy */}
      {(general.glassType === 'classic' || general.glassType === 'pair') && (
        <div
          style={{
            marginLeft: textBlockMarginLeftCoefficient * size.width,
            width: size.width * textBlockWidthCoefficient,
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {/*<div*/}
          {/*  className={`justify-center z-0 flex ${general.glassType === 'pair' ? designSlides[general.selectedCarouselNameDesignIndex].cssClass : ''}__main`}*/}
          {/*></div>*/}
          <div
            style={{
              position: 'relative',
              marginTop: textBottomCoefficient,
              maxHeight: '150px',
              zIndex: '10',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
              'weddingBackground' && (
              <img
                style={{
                  margin: 'auto',
                }}
                width={size.width / 7}
                src={pluginUrl + 'weddingRings.png'}
                color="white"
                alt="weddinDesignImg"
              />
            )}
            {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
              'heartBackground' && (
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: -size.height / 10,
                }}
                width={size.width / 7}
                src={pluginUrl + 'heartDesign.png'}
                color="white"
                alt="weddinDesignImg"
              />
            )}
            {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
              'ampBackground' && (
              <div
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: -size.height / 7,
                  fontSize: size.width / 7,
                  fontFamily: 'Roboto',
                  fontWeight: 'bold',
                  color: '#b7b7b7',
                }}
              >
                &
              </div>
            )}
            {general.glassType === 'pair' && <PairControls />}
            {general.glassType === 'classic' && <ClassicControls />}
          </div>
        </div>
      )}

      {general.glassType === 'multiple' && (
        <div
          style={{
            position: 'relative',
            width: size.width * widthCoefficient,
            height: size.height * heightCoefficient,
            zIndex: 1,
            pointerEvents: 'auto',
          }}
        >
          <MultipleImagesComponent />
        </div>
      )}
    </div>
  );
}
